App.namespace.wrap('es6.shared.field_autosave_manager', function (options = {}) {
  const FormValidation = App.es6.shared.form_validation
  const FlashAlert = App.es6.shared.flash_alert

  const AUTOSAVE_FORM_SELECTOR = '.js-default-autosave-form'  // Main form
  const AUTOSAVE_FIELD_SELECTOR = '.js-autosave-field'        // Default autosave field
  const AUTOSAVE_CONFIRM_SELECTOR = '.js-autosave-confirm'    // Field which requires confirmation before save
  const AUTOSAVE_FIELD_CONTAINER_SELECTOR = '.input-autosave' // Container holding an input field and state elements
  const AUTOSAVE_ERROR_MSG_SELECTOR = '.js-autosave-error-msg'
  const BTN_SAVE_SELECTOR = '.js-autosave-btn-save'
  const BTN_CANCEL_SELECTOR = '.js-autosave-btn-cancel'

  const HAS_CONTROLS_CLASS = 'has-controls'
  const IS_LOADING_CLASS = 'is-loading'
  const IS_SAVED_CLASS = 'is-saved'
  const IS_CONFIRMED_CLASS = 'is-confirmed'
  const IS_FAILED_CLASS = 'is-failed'

  const DATA_CURRENT_VALUE = 'current'
  const DATA_FLASH_NOTIFICATION = 'flash-notification'
  const IS_SAVED_MESSAGE_TIME = 3000
  const FIELD_DATA_SUBMIT_URL = 'submitUrl'

  const {
    $form = $(AUTOSAVE_FORM_SELECTOR),    // Form with autosave fields
    token,                                // CSRF token
  } = options

  // Fields which trigger save when changed
  const $autosaveFields = $form.find(AUTOSAVE_FIELD_SELECTOR)
  const $autosaveConfirmFields = $form.find(AUTOSAVE_CONFIRM_SELECTOR)

  // Classes for a specific states of a container
  const STATE_CLASSES = {
    default: '',
    loading: IS_LOADING_CLASS,
    saved: IS_SAVED_CLASS,
    controls: HAS_CONTROLS_CLASS,
    confirmed: IS_CONFIRMED_CLASS,
    failed: IS_FAILED_CLASS,
  }


  /**
   * Allow container to have only one state at a time
   *
   * @param $container - {jQuery} autosave field container
   * @param stateClass - class for specific state from STATE_CLASSES object
   */
  const setState = ($container, stateClass) => {
    // Remove classes for all the states, reset the container
    Object.keys(STATE_CLASSES).forEach((key) => {
        $container.removeClass(STATE_CLASSES[key])
    })

    // Block input fields for loading state, unblock for others
    $container.find('input, textarea, select').prop('disabled', stateClass === STATE_CLASSES.loading)

    // Add class specific for a given state
    $container.addClass(stateClass)
  }


  /**
   * Show error message from backend
   *
   * @param $errorField - {jQuery} where to display error message
   * @param errors - {object} containing arrays with error messages
   */
  const showErrorMessage = ({ $errorField, errors = null } = {}) => {
    let errorMsg = ''
    if (typeof errors === 'object' && errors) {
      Object.keys(errors).forEach(errorKey => {
        errorMsg += errors[errorKey].join('<br/>')
      })
    }
    if (!errorMsg) {
      errorMsg = $errorField.data('default')
    }
    $errorField.text(errorMsg)
  }


  /**
   * Store currently saved field value in its data attribute,
   * so we can detect if there were any changes on blur
   *
   * @param $field - {jQuery}
   */
  const storeCurrentFieldValue = ($field) => {
    $field.data(DATA_CURRENT_VALUE, $field.val())
  }


  /**
   * Restore previously saved field's value
   *
   * @param $field - {jQuery}
   */
  const restorePreviousFieldValue = ($field) => {
    $field.val($field.data(DATA_CURRENT_VALUE))
  }


  /**
   * If field has a data attribute with flash notification message,
   * show Flash Alert when saved properly.
   *
   * @param msg - {string} value from data-flash-notification attribute
   */
  const showFlashNotification = (msg) => {
    if (msg) {
      FlashAlert({
        $container: $form,
        message: msg,
        type: 'success',
      }).show()
    }
  }

  /**
   * Send new field value via ajax
   *
   * @param event - field blur event
   * @param doneCallback - (optional) callback after field is successfully saved
   */
  const saveField = ({ $field, doneCallback }) => {
    const $fieldContainer = $field.closest(AUTOSAVE_FIELD_CONTAINER_SELECTOR)

    // Check if the field is valid
    //
    // We create a new form validator where the form is the current field container. We do this
    // instead of creating global validator to prevent situation where the field cannot be saved,
    // because of an error with another field.
    const formValidator = FormValidation({ $form: $fieldContainer })
    if (!formValidator.validate()) {
      return
    }

    const submitUrl = $field.data(FIELD_DATA_SUBMIT_URL) || $form.attr('action')

    const data = {
      '_token': token,
    }

    // Add specific field value to data object
    if ($field.data('autosave-checkbox')) {
      data[$field.attr('name')] = $field.prop('checked');
    } else {
      data[$field.attr('name')] = $field.val()
    }

    setState($fieldContainer, STATE_CLASSES.loading)
    return $.post(submitUrl, data)
            .done(function () {
              // Save current field value also in its data attribute
              storeCurrentFieldValue($field)

              if (typeof doneCallback === 'function') {
                doneCallback()
              } else {
                setState($fieldContainer, STATE_CLASSES.saved)
                setTimeout(() => {
                  setState($fieldContainer, STATE_CLASSES.default)
                }, IS_SAVED_MESSAGE_TIME)
              }
            })
            .fail(function (response = {}) {
              setState($fieldContainer, STATE_CLASSES.failed)
              const $errorField = $fieldContainer.find(AUTOSAVE_ERROR_MSG_SELECTOR)
              showErrorMessage({ $errorField, errors: response.responseJSON })
            })
  }


  /**
   * Handle fields which require additional confirmation with buttons Save/Cancel
   *
   * @param event - field keyup event
   */
  const handleConfirmFieldChange = (event) => {
    const $field = $(event.currentTarget)
    const $fieldContainer = $field.closest(AUTOSAVE_FIELD_CONTAINER_SELECTOR)

    // Check if anything has changed
    if ($field.val() === $field.data(DATA_CURRENT_VALUE)) {
      setState($fieldContainer, STATE_CLASSES.default)
      return
    }

    // Show control buttons
    setState($fieldContainer, STATE_CLASSES.controls)

    const $btnSave = $fieldContainer.find(BTN_SAVE_SELECTOR)
    const $btnCancel = $fieldContainer.find(BTN_CANCEL_SELECTOR)

    // Callback run when field value is saved
    const doneCallback = () => {
      setState($fieldContainer, STATE_CLASSES.confirmed)
      showFlashNotification($field.data(DATA_FLASH_NOTIFICATION))
    }

    // Save new field value and set state to Confirmed
    $btnSave.off('click').on('click', function() {
      saveField({
        $field,
        doneCallback
      })
    })

    // Cancel field change and restore its value to the previously saved one
    $btnCancel.off('click').on('click', function () {
      restorePreviousFieldValue($field)
      setState($fieldContainer, STATE_CLASSES.default)
    })
  }


  const handleAutosaveFieldChange = (event) => {
    const $field = $(event.currentTarget)
    saveField({ $field })
  }


  const bindEvents = () => {
    $autosaveFields.change(handleAutosaveFieldChange)
    $autosaveConfirmFields.keyup(handleConfirmFieldChange)
  }

  const init = () => {
    bindEvents()
  }

  return {
    init,
  }
});
